import { render, staticRenderFns } from "./AddProfileSvg.vue?vue&type=template&id=86153498&scoped=true&"
import script from "./AddProfileSvg.vue?vue&type=script&lang=js&"
export * from "./AddProfileSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86153498",
  null
  
)

export default component.exports